import '../scss/styles.scss';

export default function ContactUs() {
    return (
        <section className="contact">
            <div id="contact" className="contact-wrapper">
            <div className="contact-img">
                <div className="contactImg"></div>
            </div>
            <div className="contact-text">
                    <h2>Contact Us</h2>
                    <p><span>Jeremy White</span></p>
                    <ul>
                        <li className="icons-container">
                            <a className="mail-btn"
                                href=""
                                target="_blank"
                                rel="noopener noreferrer"
                            ></a>
                            <a className="mail"
                                href=""
                                target="_blank"
                                rel="noopener noreferrer"
                            >PO Box 2717 Nantucket, MA  02584</a>
                        </li>
                        <li className="icons-container">
                            <a className="email-btn"
                                href="mailto: jwhite@farawaysoundproductions.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            ></a>
                            <a className="email"
                                href="mailto: jwhite@farawaysoundproductions.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >jwhite@farawaysoundproductions.com</a>
                        </li>
                        <li className="icons-container">
                            <a className="call-btn"
                                href="tel:4062417299"
                                target="_blank"
                                rel="noopener noreferrer"
                            ></a>
                            <a className="call"
                                href="tel:4062417299"
                                target="_blank"
                                rel="noopener noreferrer"
                            >+1-406-241-7299</a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    )
}